import { FC, ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';

interface FormFieldRowProps {
  children: ReactNode;
  gap?: number;
  sx?: BoxProps['sx'];
}

/**
 * Wrapper component for form field rows
 */
export const FormFieldRow: FC<FormFieldRowProps> = ({ children, gap = 2, sx }) => {
  return <Box sx={{ display: 'flex', gap, flexWrap: 'wrap', ...sx }}>{children}</Box>;
};
